/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component } from 'react'

import { v4 as uniqid } from 'uuid'

import { IoMailOpenOutline } from 'react-icons/io5'
import { CiCreditCard2 } from 'react-icons/ci'
import { CiBank } from 'react-icons/ci'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import BillingAddress from '@/OrderProcess/BillingAddress'
import Shipping       from '@/OrderProcess/Shipping'
import Payment        from '@/OrderProcess/Payment'
import CartPreview    from '@/OrderProcess/CartPreview'

import Loader from '@Pure/Loader'

import bemit from '@function/bemit'

import { isTrue, safeNumeral } from '@root/utility'

const numeral = window.numeral;

numeral.locale('en');

const { app, qwest } = window;

export default class OrderPage extends Component
{
	state =
	{
		payment_method: '',
		cart: [],
		can_pay: true,
		cart_fetched: isTrue(app.state.cart_fetched)
	};

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props;

		app.resetFunctions();

		app.push(
		{
			event: 'order_processChange',
			cb: component.handleOrderProcessChange
		});

		app.push(
		{
			event: 'cartChange',
			cb: component.handleCartChange
		});

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		component.handleSessionChange();
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.delete(
		{
			event: 'order_processChange',
			cb: component.handleOrderProcessChange
		});

		app.delete(
		{
			event: 'cartChange',
			cb: component.handleCartChange
		});

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleCartChange = () =>
	{
		const component = this, props = this.props;

		component.setState(
		{
			cart_fetched: isTrue(app.state.cart_fetched),

			cart: app.state.cart || []
		});
	}

	handleSessionChange = () =>
	{
		const component = this, props = this.props;

		if (!app.state.session.id) return;

		component.setState(
		{
			can_pay:
			[
				isTrue(app.state.session.permissions.pay),
				isTrue(app.state.session.permissions.can_pay)
			]
			.some(condition => condition === true)
		});
	}

	process_updates = [];

	handleOrderProcessChange = ({ source, ...params }) =>
	{
		const component = this, props = this.props;

		Object.keys(app.state.order_process).forEach(function (property)
		{
			if (property.indexOf('errors') === 0)
			{
				delete app.state.order_process[property];
			}
		});

		const req_id = params?.req_id || uniqid();

		component.process_updates.push(req_id);

		if (component.process_updates.length > 1 && !params?.req_id) return;

		qwest.post('/order-process/update',
		{
			order_process: app.state.order_process
		})
		.then(function (xhr, response)
		{
			component.process_updates = component.process_updates
			.filter(id => id !== req_id);

			if (component.process_updates.length > 0)
			{
				component.handleOrderProcessChange(
				{
					source: 'recursion', req_id: component.process_updates[0]
				});
			}
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});

		component.setState(
		{
			payment_method: app.state.order_process.payment['payment[method]']
		});
	}

	getPaymentForm = (response) =>
	{
		const component = this, props = this.props;

		component.setState(
		{
			loading: open
		});

		qwest.post('/order/get-payment-form', { order_id: response.new_order.id })
		.then(function (xhr, response)
		{
			component.setState(
			{
				loading: false
			});

			let form = document.createElement('div');

			form.innerHTML = response.payment_form;

			document.body.appendChild(form);

			component.resetStateData();

			window.requestAnimationFrame(function ()
			{
				form.querySelector('form').submit();
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);

			component.setState(
			{
				loading: false,
				error: response.error
			});
		});
	}

	resetStateData = () =>
	{
		app.state.cart = [];

		app.state.order_process =
		{
			billing: { },
			shipping: { },
			payment: { },

			fetched: true
		};
	}

	handleOrderConfirmation = () =>
	{
		const component = this, props = this.props;

		if (component.state.loading === true) return;

		component.setState(
		{
			loading: true
		});

		qwest.post('/order-process/confirm-order')
		.then(function (xhr, response)
		{
			component.setState(
			{
				loading: false
			});

			if (response.new_order)
			{
				app.state.new_order = response.new_order;

				if (app.state.session.user_abondement)
				{
					let value = numeral
					(
						safeNumeral(app.state.session.user_abondement.value)
					);

					value.subtract(safeNumeral(response.new_order.user_abondement));

					app.state.session.user_abondement.value = value.value();
				}
			}

			app.state.session = response.session || { permissions: 'not_auth' };

			app.emit('sessionChange');

			window.sessionStorage
			.setItem('open_hours_acknowledgement', false);

			if (response.new_order.payment.method === 'CC')
			{
				return component.getPaymentForm(response);
			}

			component.resetStateData();

			if (response.success === true)
			{
				props.history.push('/confirmation-de-commande');
			}
		})
		.catch(function (error, xhr, response)
		{
			app.state.order_process.errors =
			{
				billing: response.billing || { },
				shipping: response.shipping || { },
				payment: response.payment || { },
				CGV: response.CGV || { },
				VirtualWarning: response.VirtualWarning || { },
				products: response.products
			};

			app.emit('orderProcessErrorsUpdate',
			{
				source: 'orderPage',
				response: response
			});

			component.setState(
			{
				loading: false
			});

			app.ajaxRedirectLogin(response);
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const page_loading = !isTrue(state.cart_fetched);

		if (page_loading)
		{
			let page =
			(
				<Layout page_title="Ma commande" history={ props.history }>

					<div className="page-content">

						<div className="o-content standalone-loaner-container">
							<Loader className="c-loader"
								bemit={ ['white', 'bg-orange'] }
							/>
						</div>

					</div>

				</Layout>
			);

			return page;
		}
		else if (app.state.cart?.length == 0)
		{
			let page =
			(
				<Layout page_title="Ma commande" history={ props.history }>

					<div className="page-content">

						<div className="o-content standalone-loaner-container">
							<div className="c-form-message c-form-message--green">
								<div className="c-form-message__content">
									Votre panier est vide.
								</div>
							</div>
						</div>

					</div>

				</Layout>
			);

			return page;
		}

		let cannot_pay_msg =
		(
			<Layout page_title="Ma commande" history={ props.history }>

				<div className="page-content">

					<div className="o-content">
						<div className="c-form-message c-form-message--red">
							<div className="c-form-message__content">
								Vous n'avez pas les droits requis.
							</div>
						</div>
					</div>

				</div>

			</Layout>
		);

		if (!isTrue(component.state.can_pay))
		{
			return cannot_pay_msg;
		}

		let loader;

		if (state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />;
		}

		let button_text = 'Valider et payer';

		let BtnIcon;

		if (app.state.order_process.payment['payment[method]'] === 'CC')
		{
			button_text = 'Valider et payer par CB';
			BtnIcon = CiCreditCard2;
		}
		else if (app.state.order_process.payment['payment[method]'] === 'bank_transfert')
		{
			button_text = 'Valider et payer par virement';
			BtnIcon = CiBank;
		}
		else if (app.state.order_process.payment['payment[method]'] === 'check')
		{
			button_text = 'Valider et payer par chèque';
			BtnIcon = IoMailOpenOutline;
		}

		let payment_btn =
		(
			<button type="button" className="c-btn c-order-process__pay"
				onClick={ component.handleOrderConfirmation }>
				{
					BtnIcon
					? <BtnIcon className={ bemit('o-svg-icon', ['shopping-cart']) } />
					: undefined
				}
				&nbsp;
				{ button_text }
				{ loader }
			</button>
		);

		if (app.state.cart.length === 0)
		{
			payment_btn = undefined;
		}

		var output =
		(
			<Layout page_title="Ma commande" history={ props.history }
				hide_breadcrumb hide_title>

				<div className="page-content order-page-content">

					<HolidaysMessage />

					<div className="c-order-process">

						<div className="c-order-process__column">

							<BillingAddress />

						</div>

						<div className="c-order-process__column">

							<Shipping />

							<Payment />

						</div>

						<div className="c-order-process__column">

							<CartPreview>

								{ payment_btn }

							</CartPreview>

						</div>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}